//Agradecimentos especiais a: Aline Grance, Isa Costa, Gustavo Aquino, Cris (Weydson), Ernani Ávila, Washington Gama.

const actions = {
  um: {
    value: 1,
    name: '1 minuto',
    actions: ['Se esticar', 'Encher a garrafa d\'água', 'Lavar as mãos', 'Abrir a janela', 'Commitar as alterações', 'Botar o celular pra carregar', 'Agradecer alguém', 'Pingar colírio'],
  },
  umemeio: {
    value: 1.5,
    name: '1 min 30 seg',
    actions: ['Descascar uma fruta', 'Pegar um chocolatinho', 'Passar um café', 'Olhar o WhatsApp', 'Limpar o monitor'],
  },
  dois: {
    value: 2,
    name: '2 minutos',
    actions: ['Ver o Slack', 'Ler o course de novo', 'Jogar Candy Crush', 'Fazer um sanduíche', 'Treinar seu pitch'],
  },
  doisemeio: {
    value: 2.5,
    name: '2 min 30 seg',
    actions: ['Fechar os olhos e encontrar seu centro', 'Limpar o teclado', 'Arrumar a cama', 'Ir ao banheiro (nº 1)', 'Lavar o óculos'],
  },
  tres: {
    value: 3,
    name: '3 minutos',
    actions: ['Ouvir uma música', 'Fazer um miojo', 'Reiniciar o computador', 'Assistir o vídeo do Baby Shark', 'Fazer um bolo de caneca'],
  },
  quatro: {
    value: 4,
    name: '4 minutos',
    actions: ['Ferver a água', 'Limpar a sujeira do cachorro', 'Estourar uma pipoca', 'Escovar os dentes', 'Esquentar um hot pocket'],
  },
  cinco: {
    value: 5,
    name: '5 minutos',
    actions: ['Passar um café', 'Fazer um sanduíche', 'Lavar a louça', 'Ir ao banheiro (nº 2)'],
  }
}

module.exports = actions;